import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ListItem, Box, ListItemText, Typography } from '@mui/material';
var ExternalLink = function (_a) {
    var menu = _a.menu, open = _a.open;
    return (_jsx("a", { href: menu.path, target: "_blank", rel: "noreferrer", children: _jsxs(ListItem, { sx: {
                gap: 1.5,
            }, children: [_jsx(Box, { sx: {
                        width: '24px',
                        height: '24px',
                        display: 'flex',
                    }, justifyContent: "start", alignItems: "center", children: menu.icon && (_jsx("img", { srcSet: menu.icon, src: menu.icon, alt: menu.label, style: {
                            top: '4px',
                            left: '3px',
                        } })) }), open && (_jsx(ListItemText, { sx: { margin: 0 }, primary: _jsx(Typography, { variant: "body1", color: "text.main", sx: {
                            display: 'inline-block',
                            borderBottom: menu.underline ? "1px solid" : 'none',
                            borderColor: 'text.secondary',
                            verticalAlign: 'bottom',
                        }, children: menu.label }) }))] }) }));
};
export default ExternalLink;
